import {
  MagnifyingGlassIcon,
  PlayIcon,
  StopIcon,
  UpdateIcon,
} from '@radix-ui/react-icons';
import { Container, Table } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonTableButton } from 'components/common/table/button';
import { SubSectionBox } from 'components/sections/feature-demo/sub-section-box';
import { MachineContext } from 'contexts/machine.context';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext } from 'react';

const BTN_CLASS = 'width-120px';

export const ProcessesDemo = () => {
  const {
    machine,
    process_statuses,
    sendProcessQuery,
    sendProcessKill,
    sendProcessReset,
    restartFW,
    restartOS,
  } = useContext(MachineContext);

  return (
    <ErrorBoundary identifier="ProcessesDemo">
      <SubSectionBox title="Processes" source={machine.machineID}>
        <Container size="1" align="left">
          <Table.Root>
            <Table.Body>
              <Table.Row>
                <Table.RowHeaderCell>Restart</Table.RowHeaderCell>
                <Table.Cell align="center">
                  <CommonTableButton
                    icon={<UpdateIcon />}
                    label="Restart FW"
                    color={RADIX.COLOR.WARNING}
                    tooltip="This will restart the Arc processes on the machine."
                    className={BTN_CLASS}
                    onClick={() => restartFW('demo page')}
                  />
                </Table.Cell>
                <Table.Cell align="center">
                  <CommonTableButton
                    icon={<UpdateIcon />}
                    label="Restart OS"
                    color={RADIX.COLOR.DANGER}
                    tooltip="This will restart the entire operating system on the machine."
                    className={BTN_CLASS}
                    onClick={() => restartOS('demo page')}
                  />
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.RowHeaderCell>All Processes</Table.RowHeaderCell>
                <Table.Cell align="center">
                  <CommonTableButton
                    icon={<MagnifyingGlassIcon />}
                    label="Query"
                    color={RADIX.COLOR.INFO}
                    className={BTN_CLASS}
                    onClick={() => sendProcessQuery('demo page')}
                  />
                </Table.Cell>
                <Table.Cell>{/* placeholder */}</Table.Cell>
              </Table.Row>
              {process_statuses.map((process) => (
                <Table.Row key={`process-stack-${process.name}`}>
                  <Table.RowHeaderCell>{process.name}</Table.RowHeaderCell>

                  <Table.Cell align="center">
                    <CommonTableButton
                      icon={process.alive ? <UpdateIcon /> : <PlayIcon />}
                      label={process.alive ? 'Restart' : 'Start'}
                      color={
                        process.alive
                          ? RADIX.COLOR.WARNING
                          : RADIX.COLOR.SUCCESS
                      }
                      className={BTN_CLASS}
                      onClick={() =>
                        sendProcessReset('demo page', process.name)
                      }
                    />
                  </Table.Cell>
                  <Table.Cell align="center">
                    <CommonTableButton
                      icon={<StopIcon />}
                      label="Stop"
                      color={RADIX.COLOR.DANGER}
                      disabled={!process.alive}
                      className={BTN_CLASS}
                      onClick={() => sendProcessKill('demo page', process.name)}
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table.Root>
        </Container>
      </SubSectionBox>
    </ErrorBoundary>
  );
};
